import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
const useColorsList = () => {
	const { i18n } = useTranslation()
	const { language } = i18n
	const colorList = useMemo(() => {
		const colorList = [
			{
				value: 'white',
				title_uz: 'Oq',
			},
			{
				value: 'green',
				title_uz: 'Yashil',
			},
			{
				value: 'orange',
				title_uz: "Ko'k",
			},
			{
				value: 'red',
				title_uz: 'Qizil',
			},
		]
		const newColorList = colorList.map(month => ({
			...month,
			label: month?.['title_' + language],
		}))
		return newColorList
	}, [language])
	return colorList
}
export default useColorsList
